'use client'

import type { ComponentProps } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@cocoonspace/ui/components/popover'
import { SheetClose } from '@cocoonspace/ui/components/sheet'
import { useLingui } from '@lingui/react/macro'

import { LocalizedLink as Link } from '~/components/localized-link'

export const SolutionsPopover = () => {
	const { t } = useLingui()

	return (
		<Popover>
			<PopoverTrigger
				asChild
				className='hidden md:block'
			>
				<Button
					className='text-base'
					variant='text'
				>
					{t`Nos solutions`}
				</Button>
			</PopoverTrigger>

			<PopoverContent
				className='flex flex-col gap-2 p-4'
				align='start'
				sideOffset={25}
			>
				<SolutionsLinks />
			</PopoverContent>
		</Popover>
	)
}

const SolutionLink = ({
	closeOnNavigate,
	children,
	...props
}: ComponentProps<typeof Link> & { closeOnNavigate: boolean }) => {
	const link = <Link {...props}>{children}</Link>
	return closeOnNavigate ? <SheetClose asChild>{link}</SheetClose> : link
}

export const SolutionsLinks = ({
	closeOnNavigate = false,
}: {
	closeOnNavigate?: boolean
}) => {
	const { t } = useLingui()
	return (
		<>
			<SolutionLink
				closeOnNavigate={closeOnNavigate}
				className='text-foreground hover:text-primary transition-colors'
				href='https://booking-on-demand.cocoon-space.com/'
				target='_blank'
				data-umami-event='booking-on-demand-landing-navbar-click'
			>
				{t`Réservation à la demande`}
			</SolutionLink>

			<SolutionLink
				closeOnNavigate={closeOnNavigate}
				className='text-foreground hover:text-primary transition-colors'
				href='https://scheduling.cocoon-space.com/'
				target='_blank'
				data-umami-event='scheduling-landing-navbar-click'
			>
				{t`Prise de RDV présentiel`}
			</SolutionLink>
		</>
	)
}
